<template>
    <Header @language-selected="handleLanguageSelected"/>
        <section class="labels-page">
          <div class="container">
            <div class="integrations-heading privateNotes-heading">
              <h2>{{ $t('headersubmenu.Features.headerManageyourTwitter') }}</h2>
              <p>{{ $t('channels.ConnectYourAC') }}</p>
              <div class="start-button">
                <a href="https://app.bcoor.com">	{{
                  $t("automation.freeTrial")
                }}</a>
              </div>
          </div>
          <div class="labels-page-details">
            <p>{{ $t('twitterintegration.bcoor') }}  <a href="https://www.chatwoot.com/features/channels" class="omnichannel">{{ $t('twitterintegration.omnichannel') }}</a> {{ $t('twitterintegration.omnichanneldata') }}</p>
            <p class="mt-2">{{ $t('twitterintegration.twitterintegrationbcoor') }}</p>
          </div>
          <div class="labels-page-contant">
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-6 col-12">
                <!-- <div class="labels-page-img">
                  <img src="../../../assets/images/twitterIntegration/twitter-in-chatwoot.png">
                </div> -->
                 <div class="labels-page-img twitterone">
                    <img src="../../../assets/images/tweetsintegration/tweets_1297f2a7_png_4x.webp">
                  </div>
                  <div class="labels-page-img twittertwo">
                      <img src="../../../assets/images/tweetsintegration/tweets_1297f2a7_png_3x.webp">
                    </div>
                    <div class="labels-page-img twitterthree">
                      <img src="../../../assets/images/tweetsintegration/tweets_1297f2a7_png_2x.webp">
                    </div>
                    <div class="labels-page-img twitterfour">
                      <img src="../../../assets/images/tweetsintegration/tweets_1297f2a7_png_1x.webp">
                    </div>

              </div>
              <div class="col-lg-6 col-md-6 col-12">
                <div class="labels-page-img-details">
                  <h4>{{ $t('twitterintegration.twitterintegrationInteract') }}</h4>
                  <p>{{ $t('twitterintegration.twitterintegrationManage') }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="labels-page-contant">
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-6 col-12 orderr-2">
                <div class="labels-page-img-details">
                  <h4>{{ $t('smsintegration.smsintegrationQuick') }}</h4>
                  <p>{{ $t('twitterintegration.twitterintegrationnative') }}</p>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-12 orderr-1">
                <div class="labels-page-img">
                  <img src="../../../assets/images/twitterIntegration/adding-twitter-to-chatwoot.png">
                </div>
              </div>
            </div>
            </div>

            
          

          <div class="conversations d-none">
              <div class="row align-items-center">
                <div class="col-lg-6">
                  <div class="conversations-heading">
                    <h3>{{ $t('twitterintegration.twitterintegrationinteractions') }}</h3>
                    <p> {{ $t('automation.conversations') }}</p>
                    <div class="signup-button">
                      <a href="https://app.bcoor.com">{{ $t('emailIntegration.sign_up_free') }}</a>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="conversations-img">
                    <img src="../../../assets/images/automations/dashboard-small.webp">
                  </div>
                </div>
              </div>
          </div>
          </div>

        </section>
    <Footer :selectLanguage="selectLanguage"/>
</template>

<script>
    import Footer from "@/views/chatwoot/Footer.vue";
        import Header from "@/views/chatwoot/Header.vue";
    
        export default {
      name: "sharedInbox",
      components: {
        Footer,
        Header
      },
          data () {
            return {
              selectLanguage: 'en',
            };
          },
          methods: {
            handleLanguageSelected (language) {
              this.selectLanguage = language;
            },
          },
          created() {
            const localStorageItem = localStorage.getItem('language');

            if (localStorageItem) {

              this.selectLanguage = localStorageItem;
            }
          }
    }
    </script>
